import { Navigate, Route, Routes } from 'hotel/navigation';

import Roster from '../pages/Roster';

const RosterRoutes = () => {
  return (
    <Routes>
      <Route index element={<Roster />} />
      <Route path="*" element={<Navigate to="/roster" />} />
    </Routes>
  );
};

export default RosterRoutes;
